/**
 * 에이전트 쿼리 키 팩토리.
 *
 * **두 슬라이스가 같은 루트를 쓴다** — `features/agent`(관리 화면: 목록·상세·지표·CRUD)와
 * `features/assistant`(어시스턴트가 고를 에이전트 목록). 둘 다 `['agents']` 라 캐시를
 * 공유하고, 관리 화면의 무효화 3곳이 어시스턴트 쪽 목록에도 닿는다(의도된 동작).
 *
 * features 끼리는 서로 import 할 수 없으므로 키를 `shared/api` 에 둔다 —
 * `questKeys.ts` 와 같은 자리다(PR #1631 에서 같은 이유로 이사했다).
 *
 * 회귀 가드: `__tests__/agentKeys.test.ts`.
 */
import { defineQueryKeys } from '@/shared/lib/queryKeys';

export const agentKeys = defineQueryKeys('agents', (all) => ({
  /** 목록 — 루트 그 자체가 키다. 두 슬라이스가 공유한다. */
  list: () => [...all] as const,
  detail: (id: string) => [...all, id] as const,
  metrics: (id: string) => [...all, id, 'metrics'] as const,
}));
